import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { DataValidation } from '@model/data-validation';
import { routes } from '@model/constants/routes';
import { ConditionTermsSource } from '@core/model/enums/condition-terms-source';

@Injectable({
  providedIn: 'root',
})
export class DataValidationService {
  apiUrl = environment.apiUrl;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public getDataTerms(source: string): any {
    if (source == ConditionTermsSource.dataValidation) {
      return this.http.get<any>(this.apiUrl + routes.getDataTerms, { headers: this.headers });
    }
  }

  public DataValidationService(dataValidation: DataValidation): Observable<any> {
    const data = {
      termAndConditions: dataValidation.termAndConditions,
      productType: dataValidation.productType,
      token: dataValidation.token,
      origin: dataValidation.origin,
      amount: dataValidation.amount,
      term: dataValidation.term,
    };

    return this.http.post<any>(this.apiUrl + routes.DataValidationService, data, { headers: getHttpHeaders() });
  }
}
